var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcloseX = function SvgIconcloseX(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icon.close_x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icon.close_x",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5107955,0.434947917 C14.0622442,0.981839261 14.1001734,1.85075177 13.6220942,2.44190131 L13.5195975,2.55625 L9.112,6.99999992 L13.5195975,11.44375 C14.1029483,12.031962 14.0990075,12.9817013 13.5107955,13.5650521 C12.9593467,14.1119434 12.0901493,14.1426605 11.5029875,13.6596921 L11.3894934,13.55625 L7,9.13 L2.61050663,13.55625 C2.02715586,14.144462 1.07741657,14.1484028 0.489204546,13.5650521 C-0.0622442255,13.0181607 -0.100173391,12.1492482 0.37790578,11.5580987 L0.480402463,11.44375 L4.887,6.99999992 L0.480402463,2.55625 C-0.102948304,1.96803798 -0.099007477,1.01829868 0.489204546,0.434947917 C1.04065332,-0.111943426 1.90985067,-0.142660518 2.49701246,0.340307912 L2.61050663,0.443750001 L7,4.869 L11.3894934,0.443750001 C11.9728441,-0.144462022 12.9225834,-0.148402849 13.5107955,0.434947917 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcloseX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.close_x.fa66fb80caf655055eda0c3fb18f2102.svg";